export default __webpack_public_path__ + "static/industry_one_mark-46b732214ab3e4325b1299909da75b81.png";